import { render, staticRenderFns } from "./AccettazioneSsnListaPage.vue?vue&type=template&id=8f247b4c&scoped=true"
import script from "./AccettazioneSsnListaPage.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnListaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f247b4c",
  null
  
)

export default component.exports